<script>
import { Line } from 'vue-chartjs'
// import Trendline from 'chartjs-plugin-trendline'

function formatNumber (value) {
  return (new Intl.NumberFormat('en-US')).format(value)
}

export default {
  extends: Line,
  props: {
    consignmentTrends: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    chartdata: {
      labels: [],
      datasets: [
        {
          type: 'line',
          label: 'Weight',
          yAxisID: 'y-axis-0',
          data: [],
          spanGaps: false,
          borderWidth: 2,
          borderColor: '#ffd166',
          fill: true,
          backgroundColor: 'rgba(255, 209, 102, 0.035)'
        },
        {
          type: 'line',
          label: 'Items',
          spanGaps: false,
          yAxisID: 'y-axis-1',
          data: [],
          borderColor: '#06d6a0',
          borderWidth: 2,
          fill: true,
          backgroundColor: 'rgba(6, 214, 159, 0.035)'
        },
        {
          type: 'line',
          label: 'Consignments',
          spanGaps: false,
          yAxisID: 'y-axis-1',
          data: [],
          borderColor: '#118ab2',
          borderWidth: 2,
          fill: true,
          backgroundColor: 'rgba(17, 138, 178, 0.035)'
        }
      ]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      tooltips: {
        intersect: false,
        mode: 'index',
        callbacks: {
          label: function (tooltipItems, data) {
            let labelLeft = data.datasets[tooltipItems.datasetIndex].label + ': '
            let labelRight = formatNumber(tooltipItems.yLabel)

            if (tooltipItems.datasetIndex === 0) {
              labelRight = labelRight + 'kg'
            }

            return labelLeft + labelRight
          }
        }
      },
      scales: {
        xAxes: [
          {
            ticks: {
              autoskip: true,
              minRotation: 45
            }
          }
        ],
        yAxes: [
          {
            id: 'y-axis-0',
            type: 'linear',
            position: 'left',
            scaleLabel: {
              display: false,
              labelString: 'Weight',
              padding: 20
            },
            ticks: {
              beginAtZero: true,
              callback: function (value) {
                return formatNumber(value) + 'kg'
              }
            }
          },
          {
            id: 'y-axis-1',
            type: 'linear',
            position: 'right',
            scaleLabel: {
              display: false,
              labelString: 'Consignments & Items',
              padding: 20
            },
            gridLines: {
              display: false
            },
            ticks: {
              beginAtZero: true,
              callback: function (value) {
                return formatNumber(value)
              }
            }
          }
        ]
      },
      legend: {
        display: true,
        labels: {
          usePointStyle: true
        },
        onClick: null
      },
      layout: {
        padding: {
          left: 20,
          right: 30,
          top: 10,
          bottom: 10
        }
      },
      elements: {
        point: {
          radius: 0
        }
      }
    }
  }),
  mounted () {
    this.chartdata.labels = this.$props.consignmentTrends.map(d => d.label)
    this.chartdata.datasets[0].data = this.$props.consignmentTrends.map(d => d.weight)
    this.chartdata.datasets[1].data = this.$props.consignmentTrends.map(d => d.items)
    this.chartdata.datasets[2].data = this.$props.consignmentTrends.map(d => d.consignments)

    // Add extra padding to the legend
    this.addPlugin({
      beforeInit: function (chart) {
        chart.legend.afterFit = function () {
          this.height = this.height + 20
        }
      }
    })

    // this.addPlugin(Trendline)
    this.renderChart(this.chartdata, this.options)
  }
}
</script>
